import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import { Card } from 'reactstrap';
import Spinner from '~/components/spinner/spinner';
import URLParamBanner from '~/components/urlParamBanner/urlParamBanner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getTransferSchedulesQuery = gql`
  query transferSchedules($breweryId: Int!) {
    transferSchedules(breweryId: $breweryId) {
      id
      name
      description
      isConsolidated
      transfers {
        id
      }
    }
  }
`;

const TransferSchedulesList = ({ brewery, history }) => (
  <Query query={getTransferSchedulesQuery} variables={{ breweryId: brewery.id }}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      return (
        <Fragment>
          <URLParamBanner name="transfer schedule" />
          <Card className="content">
            <table className="table mb0">
              <thead>
                <tr>
                  <th className="bt-n bb-n">Name</th>
                  <th className="bt-n bb-n">Description</th>
                  <th className="bt-n bb-n"># of transfers</th>
                  <th className="bt-n bb-n">Consolidated only</th>
                </tr>
              </thead>
              <tbody>
                {data.transferSchedules.map(transferSchedule => (
                  <tr
                    className="table-row pointer"
                    key={transferSchedule.id}
                    onClick={() => {
                      history.push(`/settings/transfers/${transferSchedule.id}`);
                    }}
                  >
                    <td>
                      <strong>{transferSchedule.name}</strong>
                    </td>
                    <td className="mw6">{transferSchedule.description}</td>
                    <td className="mw6">
                      {transferSchedule.transfers ? transferSchedule.transfers.length : '?'} transfers
                    </td>
                    <td className="mw6">{transferSchedule.isConsolidated ? 'Yes' : ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </Fragment>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(TransferSchedulesList));



// WEBPACK FOOTER //
// ./src/containers/transferSchedulesList/transferSchedulesList.jsx